// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"73090":"20bef96a7ffdfab0","83799":"6cd1e9bd9ea74dad"}[chunkId] + ".css";
};